import React from 'react';
import { Provider } from 'react-redux';
// import Hidden from '@material-ui/core/Hidden';
import ReactOnRails from 'react-on-rails';
import { ApolloProvider } from '@apollo/client';
import apolloClient from 'appDir/lib/apollo/client';

import BottomNavigationContainer from '../layout/BottomNavigationContainer';
import useSetApolloCache from 'appDir/routes/useSetApolloCache';

const BottomNavigationAppWrapped = ({ railsContext }) => {
  const cacheLoaded = useSetApolloCache(railsContext);

  if (!cacheLoaded) return null;
  return <BottomNavigationContainer />;
};

const BottomNavigationApp = (_props, railsContext) => {
  const { store } = ReactOnRails.getStore('appStore');

  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <BottomNavigationAppWrapped railsContext={railsContext} />
      </Provider>
    </ApolloProvider>
  );
};

export default BottomNavigationApp;
